/** Dollars as typed ("1,000.50", "$250") to whole cents; null when it isn't an amount. */
export function dollarsToCents(text: string): number | null {
  const cleaned = text.trim().replace(/[$,\s]/g, '');
  if (!/^(\d+\.?\d{0,2}|\.\d{1,2})$/.test(cleaned)) return null;
  return Math.round(parseFloat(cleaned) * 100);
}

/** Cents as the dollars an input shows: 25000 -> "250.00". */
export function centsToDollars(cents: number): string {
  return (cents / 100).toFixed(2);
}
